/** Session lifecycle status (numeric wire values from backend). */
export default Object.freeze({
  Created: 0,
  Online: 1,
  Offline: 2,
  Replaced: 3,
  Revoked: 4,
});
